import { createSlice } from '@reduxjs/toolkit';
import { ITeamManagement } from './TeamManagement.type';

export interface TeamManagementState {
  isUpdateListTeam: boolean;
  isUpdateTeamUser: boolean;
  currentSelectedProject: any;
  teamDeatil: Partial<ITeamManagement>;
}

const initialState: TeamManagementState = {
  isUpdateListTeam: false,
  isUpdateTeamUser: false,
  currentSelectedProject: null,
  teamDeatil: {},
};

export const teamManagementSlice = createSlice({
  name: 'TeamManagement',
  initialState,
  reducers: {
    triggerIsUpdateListTeam: state => {
      state.isUpdateListTeam = !state.isUpdateListTeam;
    },
    triggerIsUpdateTeamUser: state => {
      state.isUpdateTeamUser = !state.isUpdateTeamUser;
    },
    setTeamDeatil: (state, action) => {
      state.teamDeatil = action.payload;
    },
  },
  extraReducers: builder => {},
});

export const { triggerIsUpdateListTeam, setTeamDeatil, triggerIsUpdateTeamUser } = teamManagementSlice.actions;
export default teamManagementSlice.reducer;
